export default {
  "nl": {
    "reminder": {
      "actions": {
        "cancel": "Annuleer",
        "edit": "Bewerken",
        "hideReminders": "Verberg herinneringen",
        "save": "Sla op",
        "showReminders": "Toon herinneringen"
      },
      "contactType": {
        "customer": "Klant",
        "partner": "partner"
      },
      "labels": {
        "after": "na",
        "before": "voor",
        "click": "Klik hier om een herinnering in te stellen",
        "date": "op {date}",
        "dateAfterDueDate": "Na deadline",
        "dateAlreadyPassed": "datum is al voorbij",
        "decisionApprovedNotSent": "De beslissing is genomen. Herinneringen die nog in de wachtrij stonden werden geannuleerd.",
        "dueDate": "de deadline",
        "here": "hier",
        "noReminderSet": "Geen herinnering ingesteld",
        "reminder": "Herinnering",
        "reminders": "Herinneringen",
        "remindersCustomer": "Herinneringen voor de klant",
        "remindersPartners": "Herinneringen voor de partner(s)",
        "sendOnDeadline": "Herinnering zal gestuurd worden op de dag van de deadline",
        "sendReminder": "Stuur herinnering",
        "sent_at": "Herinnering verzonden op {date}",
        "warningReminders": "Alle 4 herinneringen worden overschreven voor elke beslissing, ook degene die niet zijn ingevuld."
      },
      "toasts": {
        "update": "Herinnering succesvol bijgewerkt"
      }
    }
  }
}